import React, {useEffect, useState} from "react";
import Navigation from "./Navigation";
import Banner from "./Banner";
import Footer from "./Footer";
import {Link} from "react-router-dom";
import HomeContactForm from "./HomeContactForm";

function Home() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [expandedCards, setExpandedCards] = useState({});

    const toggleExpand = (index) => {
        setExpandedCards((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + "...";
        }
        return text;
    };

    const solutionsSectionData = [
        {
            heading: "Increase Order Volume",
            img: "/assets/Increased Order Volume.png",
            detail: `Guests no longer wait on hold, reducing abandoned calls and lost orders. No missed calls due to busy lines, or idle employees, even near closing time.`,
        },
        {
            heading: "Reduce Labor Cost",
            img: "/assets/Decrease in Labor Cost.png",
            detail: `Payment is contingent on call volume at a flat rate, excluding FICA, FUTA, SUTA, workers' compensation, and additional payroll expenses.`,
        },
        {
            heading: "Increase Efficiency",
            img: "/assets/Reduce Cooking Time.png",
            detail: `Reduce Cooking time by over a minute, cutting interruptions and streamlining operations, so in-house staff can better focus on guests.`,
        },
        {
            heading: "Top-Tier Support",
            img: "/assets/High Support.png",
            detail: `Our friendly call center agents represent your restaurant, ensuring no customer waits. Brand-trained agents impressing with our efficient QSR system.`,
        },
    ];
    return (
        <>
            <div className="banner-section-outer">
                <Navigation/>
                <Banner/>
            </div>
            <section className="solutions-section">
                <div className="container">
                    <div className="row wow slideinLeft" data-wow-duration="2s">
                        {solutionsSectionData?.map((data, i) => (
                            <div
                                key={i}
                                className="col-md-3 col-sm-6 mb-md-0 mb-4 text-md-left text-center"
                            >
                                <div className="solutions-section-plan-box hover-effect">
                                    <img src={data.img} alt=""/>
                                    <h4>{data.heading}</h4>
                                    <p
                                        style={{whiteSpace: "pre-line"}}
                                        className="text-size-16 pt-3"
                                    >
                                        {expandedCards[i]
                                            ? data.detail
                                            : truncateText(data.detail, 99999999)}
                                    </p>
                                    {/*<a*/}
                                    {/*  className="d-inline-block text-decoration-none"*/}
                                    {/*  onClick={() => toggleExpand(i)}*/}
                                    {/*  style={{ cursor: 'pointer' }}*/}
                                    {/*>*/}
                                    {/*  {expandedCards[i] ? 'Read Less' : 'Read More'}*/}
                                    {/*  <i className="far fa-long-arrow-alt-right position-relative"></i>*/}
                                    {/*</a>*/}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="services-section position-relative">
                <div className="container">
                    <div className="row">
                        <div className="services-section-inner text-center position-relative col-12">
                            <h2 className="mb-lg-4 mb-md-3 mb-2">How it Works?</h2>
                            <p className="mb-0">
                                It’s a simple process
                                <br/>
                                <strong>Perfect Call Center Integration</strong>
                                <br/>
                                Orders processed as if call agent is standing at your store
                                counter
                            </p>
                            <div className="col-12 mt-5">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="et_pb_module et_pb_image et_pb_image_1">
                      <span className="et_pb_image_wrap ">
                        <img
                            decoding="async"
                            className="w-75 h-auto"
                            src="/assets/images/how-it-works-1.png"
                        />
                      </span>
                                        </div>
                                        <div className="et_pb_text_inner">
                                            <p className="text-center">
                                                Customer calls your restaurant
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="et_pb_module et_pb_image et_pb_image_1">
                      <span className="et_pb_image_wrap ">
                        <img
                            decoding="async"
                            className="w-75 h-auto"
                            src="/assets/images/how-it-works-2.png"
                        />
                      </span>
                                        </div>
                                        <div className="et_pb_text_inner">
                                            <p className="text-center">
                                                We route the call to the call center service
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="et_pb_module et_pb_image et_pb_image_1">
                      <span className="et_pb_image_wrap ">
                        <img
                            decoding="async"
                            className="w-75 h-auto"
                            src="/assets/images/how-it-works-3.png"
                        />
                      </span>
                                        </div>
                                        <div className="et_pb_text_inner">
                                            <p className="text-center">
                                                Order processed to your POS{" "}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="et_pb_module et_pb_image et_pb_image_1">
                      <span className="et_pb_image_wrap ">
                        <img
                            decoding="async"
                            className="w-75 h-auto"
                            src="/assets/images/how-it-works-4.png"
                        />
                      </span>
                                        </div>
                                        <div className="et_pb_text_inner">
                                            <p className="text-center">Your store makes the meal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <figure className="services-section-shape-img-1 mb-0 position-absolute">
                                <img
                                    className="img-fluid"
                                    src="/assets/images/services-section-shape-img-1.png"
                                    alt=""
                                />
                            </figure>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-md-0 mb-4 text-center pb-3">
                            <h2>Why Us?</h2>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">Increase Average Ticket</h4>
                                <p>
                                    Discover how our strategic approach and personalized upselling
                                    techniques can boost your average ticket price,
                                    driving increased revenue.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">Improve Customer Service</h4>
                                <p>
                                    Elevate your customer service standards with our tailored
                                    solutions and dedicated support, ensuring satisfaction and
                                    loyalty among your clientele.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">
                                    Increase Productivity
                                </h4>
                                <p>
                                    Unlock the full potential of your workforce with our
                                    innovative tools and training programs, enhancing efficiency
                                    and driving productivity across your organization.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">Reduce Labor Cost</h4>
                                <p>
                                    Experience significant cost savings through our streamlined
                                    processes and efficient management solutions, optimizing
                                    resources without compromising quality or service.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">
                                    Increase Total Transactions
                                </h4>
                                <p>
                                    Transform your business with our proven strategies and
                                    cutting-edge technology, driving a surge in total transactions
                                    and unlocking new levels of growth.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center pb-3">
                            <div className="services-section-plan-box hover-effect">
                                <h4 className="font-weight-bold">Reduce Employee Turnover</h4>
                                <p>
                                    Boost your team's dedication with our supportive culture and professional growth
                                    opportunities, reducing turnover and enhancing long-term employee satisfaction.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*<HomeContactForm />*/}

            <Footer/>
        </>
    );
}

export default Home;
